export interface Language {
  name: string;
  script: string;
  native: string;
}

export interface LanguageMap {
  [key: string]: Language;
}

export const DEFAULT_LANGUAGES: LanguageMap = {
  en: { name: 'English', script: 'Latn', native: 'English' },
  es: { name: 'Spanish', script: 'Latn', native: 'español' },
  pl: { name: 'Polish', script: 'Latn', native: 'polski' },
  ru: { name: 'Russian', script: 'Cyrl', native: 'русский' },
  uk: { name: 'Ukrainian', script: 'Cyrl', native: 'українська' }
};
